var _defs, _g, _text, _text2, _line, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWithWriting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "50 25 520 200",
    width: 520,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .nur   { font-family: 'Georgia','Times New Roman',serif; font-size: 52px; font-weight: bold; fill: #2a1018; letter-spacing: 1px; }\n      .treff { font-family: 'Georgia','Times New Roman',serif; font-size: 52px; font-style: italic; fill: #7d2338; letter-spacing: 1px; }\n      .tag   { font-family: 'Helvetica Neue','Arial',sans-serif; font-size: 11px; fill: #9a8880; letter-spacing: 3.5px; }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 148 C80 148, 8 102, 8 48              C8 22, 26 4, 48 4              C62 4, 74 12, 80 22              C86 12, 98 4, 112 4              C134 4, 152 22, 152 48              C152 102, 80 148, 80 148 Z",
    fill: "#fdf8f3",
    stroke: "#7d2338",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 98,
    x2: 34,
    y2: 42,
    stroke: "#7d2338",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 42,
    x2: 68,
    y2: 98,
    stroke: "#7d2338",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 98,
    x2: 68,
    y2: 42,
    stroke: "#7d2338",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 42,
    x2: 120,
    y2: 42,
    stroke: "#a84058",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 42,
    x2: 100,
    y2: 98,
    stroke: "#a84058",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 116,
    r: 7,
    fill: "#7d2338",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 142 C40 128, 72 128, 72 142",
    fill: "none",
    stroke: "#7d2338",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 116,
    r: 7,
    fill: "#7d2338",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 142 C84 128, 116 128, 116 142",
    fill: "none",
    stroke: "#7d2338",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    opacity: 0.35
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 120,
    className: "nur"
  }, "Nur")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 178,
    className: "treff"
  }, "Treffen")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 190,
    x2: 560,
    y2: 190,
    stroke: "#7d2338",
    strokeWidth: 1,
    opacity: 0.2
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 210,
    className: "tag"
  }, "WO BEGEGNUNGEN BEGINNEN")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithWriting);
export default __webpack_public_path__ + "static/media/logo-with-writing.6feffd143c8256a4233ee99e9bfe2c3e.svg";
export { ForwardRef as ReactComponent };